import React from "react";
import "../products/productDetail.css";

const DivisionViewTable = ({ divisionViewData }) => {
  console.log(divisionViewData);
  const reimbursementOptions = {
    forward_cfa: "Full Order Forward from CFA",
    order_off_qty: "Order Offer Quantity",
    full_order_qty: "Full Order Quantity",
    credit_note: "Credit Note for Offer",
  };
  return (
    <>
      <div className="mb-4">
        <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
          Basic Details
        </div>
        <div className="product-details-container">
          <div className="container-div">
            <span className="label-id color_747f9e">Division Name</span>
            <span className="id-number text-capitalize">
              {divisionViewData.name ? divisionViewData.name : "--"}
            </span>
          </div>
          <div className="container-div">
            <span className="label-id color_747f9e">Offer Type</span>
            <span className="id-number text-capitalize">
              {divisionViewData.offer_type ? divisionViewData.offer_type : "--"}
            </span>
          </div>
          <div className="container-div">
            <span className="label-id color_747f9e">Approval Level</span>
            <span className="id-number text-capitalize">
              {divisionViewData.approval_level
                ? divisionViewData.approval_level
                : "--"}
            </span>
          </div>
          <div className="container-div">
            <span className="label-id color_747f9e">Reimbursement Method</span>
            <span className="id-number text-capitalize color_b0b3c7">
              {divisionViewData.reimbursement_method
                ? reimbursementOptions[divisionViewData.reimbursement_method]
                : "--"}
            </span>
          </div>
          <div className="container-div">
            <span className="label-id color_747f9e">Set Order Limit</span>
            <span className="id-number text-capitalize">{`${
              divisionViewData?.order_limit
                ? divisionViewData?.order_limit
                : "--"
            } - ${
              divisionViewData?.order_amount
                ? divisionViewData?.order_amount
                : "--"
            }`}</span>
          </div>
          <div className="container-div">
            <span className="label-id color_747f9e">Status</span>
            <span className="id-number">
              {divisionViewData?.status == true ? (
                <span className="text_green fs_15">Active</span>
              ) : (
                <span className="text_red fs_15">Inactive</span>
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default DivisionViewTable;
